module.exports = __webpack_public_path__ + "img/biochemicals.a2f35c51.jpg";